import { Timestamp } from 'firebase/firestore'

import { AutosaveStatusByField } from '../../types/autosave.types'
import type { AppFormControl } from '../../../../types/form.types'
import type { PhoneFormValue } from '../../../../utils/phone.utils'

export enum PlanLevel {
  Starter = 1,
  Standard = 2,
  Advanced = 3,
  Unlimited = 4,
}

export type BannerPosition = 'left' | 'center' | 'right'

export const DEFAULT_BANNER_POSITION: BannerPosition = 'center'

export type GeneralConfigurationAutosaveField =
  | 'pricingPlan'
  | 'bannerTitle'
  | 'bannerSubtitle'
  | 'bannerPosition'
  | 'infoTitle'
  | 'infoText'
  | 'websiteUrl'
  | 'facebookUrl'
  | 'instaUrl'
  | 'contactPhone'
  | 'contact'
  | 'pricelist'
  | 'services'
  | 'reservationPolicy'
  | 'privacyPolicy'

export interface GeneralConfigurationProps {
  control: AppFormControl
  bannerFilename: string
  logoFilename: string
  autosaveStatusByField: AutosaveStatusByField<GeneralConfigurationAutosaveField>
}

export type GeneralConfigurationForm = Omit<GeneralConfigurationType, 'contactPhone'> & {
  bannerFile?: File
  logoFile?: File
  contactPhoneInput: PhoneFormValue
}

export interface GeneralConfigurationType {
  pricingPlan: number
  banner: string
  logo: string
  bannerTitle: string
  bannerSubtitle: string
  bannerPosition: BannerPosition
  infoTitle: string
  infoText: string
  contact: string
  services: string
  pricelist: string
  reservationPolicy: string
  privacyPolicy: string
  instaUrl: string
  facebookUrl: string
  websiteUrl: string
  contactPhone: string
  updatedAt: Timestamp
}
